import {useEffect, useRef} from 'react';
import {Animated} from 'react-native';

import {
  startOpacityAnimation,
  startShakeAnimations,
  startSlideUpDownAnimations,
} from './Cell.util';

interface UseCellProps {
  isWrongPin: boolean;
  id: number;
  focused: boolean;
  valueLength: number;
  slidesUpDownAnimation: Animated.Value;
}

interface UseCellReturn {
  currentCellFilled: boolean;
  cellFilled: boolean;
  opacityAnimation: Animated.Value;
  shakeAnimation: Animated.Value;
}

export const useCell = ({
  isWrongPin,
  id,
  focused,
  valueLength,
  slidesUpDownAnimation,
}: UseCellProps): UseCellReturn => {
  const shakeAnimation = useRef(new Animated.Value(0)).current;
  const opacityAnimation = useRef(new Animated.Value(1)).current;
  const currentCellFilled = focused && id + 1 === valueLength;
  const cellFilled = id < valueLength;

  useEffect(() => {
    if (currentCellFilled && !isWrongPin && valueLength !== 0) {
      startSlideUpDownAnimations(slidesUpDownAnimation);
    }
    if (isWrongPin && valueLength !== 0) {
      startShakeAnimations(shakeAnimation);
      startOpacityAnimation(opacityAnimation);
    }
  }, [isWrongPin, currentCellFilled]);

  return {
    currentCellFilled,
    cellFilled,
    opacityAnimation,
    shakeAnimation,
  };
};
